import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import NosotrosPage from './pages/NosotrosPage';
import CatalogosPage from './pages/CatalogosPage';
import OcasionesPage from './pages/OcasionesPage';
import GaleriaPage from './pages/GaleriaPage';
import ContactoPage from './pages/ContactoPage';
import ProductoPage from './pages/ProductoPage';
import OcasionPage from './pages/OcasionPage';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Footer from './components/Footer';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nosotros" element={<NosotrosPage />} />
            <Route path="/catalogos" element={<CatalogosPage />} />
            <Route path="/ocasiones" element={<OcasionesPage />} />
            <Route path="/galeria" element={<GaleriaPage />} />
            <Route path="/contacto" element={<ContactoPage />} />
            <Route path="/producto/:categoria" element={<ProductoPage />} />
            <Route path="/ocasion/:tipo" element={<OcasionPage />} />
          </Routes>
          <Footer />
          <FloatingWhatsApp />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;